export class AudioWorkletUrl {
  constructor(url: any) {
    return url;
  }
}
